import React, { createContext, useReducer, useEffect } from "react";

export const AuthContext = createContext(null);

const initialState = {
  user:            null,
  token:           null,
  isAuthenticated: false,
  isLoading:       true,
  error:           null,
};

const authReducer = (state, action) => {
  switch (action.type) {
    case "AUTH_LOADING":
      return { ...state, isLoading: true, error: null };
    case "AUTH_IDLE":
      return { ...state, isLoading: false, error: null };
    case "AUTH_SUCCESS":
      return { ...state, user: action.payload.user, token: action.payload.token, isAuthenticated: true, isLoading: false, error: null };
    case "AUTH_LOGOUT":
      return { ...initialState, isLoading: false };
    case "AUTH_ERROR":
      return { ...state, isLoading: false, error: action.payload };
    case "AUTH_UPDATE_USER":
      return { ...state, user: state.user ? { ...state.user, ...action.payload } : action.payload };
    default:
      return state;
  }
};

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  useEffect(() => {
    const hydrate = async () => {
      const token = localStorage.getItem("access_token");
      const raw   = localStorage.getItem("cached_user");

      if (!token) {
        dispatch({ type: "AUTH_LOGOUT" });
        return;
      }

      // Use cached user for instant render
      if (raw) {
        try {
          const user = JSON.parse(raw);
          dispatch({ type: "AUTH_SUCCESS", payload: { user, token } });
        } catch {
          dispatch({ type: "AUTH_LOGOUT" });
        }
        return;
      }

      // No cached user — verify token with server
      try {
        // Dynamic import to avoid circular deps
        const { default: authService } = await import("../services/authService");
        const user = await authService.getMe();
        localStorage.setItem("cached_user", JSON.stringify(user));
        dispatch({ type: "AUTH_SUCCESS", payload: { user, token } });
      } catch {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        dispatch({ type: "AUTH_LOGOUT" });
      }
    };

    hydrate();
  }, []);

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;